import { format, parseISO } from "date-fns";

export function randomNumber(number: number) {
  return Math.floor(Math.random() * number) + 1;
}

export function randomNumberRange(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomInArray<T>(array: T[]) {
  return array[Math.floor(Math.random() * array.length)];
}

export function formatDateWithTime(dateString: any) {
  if (!dateString) return "";
  return format(new Date(dateString), "MM/dd/yy p");
}

export function formatUTCDateWithLocalTime(utcTimestamp: string | number | Date) {
  if (!utcTimestamp) return "";

  // Add 'Z' to indicate UTC if it's a string without timezone info
  let timestamp = utcTimestamp;
  if (typeof timestamp === "string" && !timestamp.endsWith("Z") && !timestamp.includes("+")) {
    timestamp = `${timestamp}Z`;
  }

  const date = new Date(timestamp);
  return format(date, "MM/dd/yy p");
}

export function formatDate(dateString: any) {
  if (!dateString) return "";
  return format(new Date(dateString), "MM/dd/yy");
}

export const parseMs = (v: unknown): number => {
  if (v instanceof Date) return v.getTime();

  if (typeof v === "string") {
    const s = v.trim().replace(" ", "T");
    // If it has no timezone, assume it's UTC and append Z
    const hasTz = /[Zz]|[+\-]\d{2}:\d{2}$/.test(s);
    const iso = hasTz ? s : s + "Z";
    const t = Date.parse(iso);
    return Number.isNaN(t) ? -Infinity : t;
  }

  return -Infinity;
};
